$(document).ready(function ($) {
  "use strict"; 
  function megaMenu() {
    if($('.default_dropdown').length > 0 ) {
    if ($("#header .page-full-width").length) {
      var parentRow = $("#header .page-full-width > .row");
      var parentLeft = parseInt(parentRow.css("marginLeft").replace("px", ""));
    } else {
      var parentRow = $("#header .page-width .row");
      var parentLeft = parseInt(parentRow.offset().left);
    }
    var parentWidth = parentRow.width();

    $("#header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > a").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);
        thisItem.find(".sub-menu-block").css("width", parentWidth);
       }
    });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > a").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);        
        thisItem.find(".sub-menu-block").css("width", parentWidth);      
      }
    });
    window.setTimeout(function () {
      $(window).trigger("resize");
    }, 800);

    }
  }
  var megaMenuResize = false;
  $(window).bind("resize", function () {
    if (!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
});

$(function () {
  if ($(window).width() >= 1200) {
    $(".deskTabs a").click(function () {
      let id = $(this).attr("href");
      $(".deskTabs li").removeClass("active");
      $(this).parent().addClass("active");
      $(this).parent().parent().parent().parent().addClass("active");
      $(".tabs-content li.dt-sc-menu-tabs").hide();
      $(this).parent().parent().parent().parent().find(id).show();

      return false;
    });
  }
  if ($(window).width() <= 1199) {
    $(".mobileTabs .tabs  li").each(function () {
      $(this).click(function () {
        $(this).next("div").slideToggle(0);
      });
    });
  }
});
$(document).ready(function () {
  $("#category-menu-button").click(function () {
    $(this).toggleClass("open");
    $(".category-wrapper").toggleClass("open");
    $(".category-wrapper").slideToggle(0);
  });

  // Desktop & mobile sub-menu click interaction
  $(document).on("click", "ul.dt-nav > li.menu-item-has-children > .megamenu_megamenu > a.dt-sc-nav-link", function (e) {
    var $li = $(this).closest("li.menu-item-has-children");
    var href = $(this).attr("href");
    var hasSub = $li.find(".sub-menu-block").length > 0;

    if (hasSub) {
      // If href is hash/empty or if item isn't open yet, toggle and prevent default navigation
      if (!href || href === "#" || href === "javascript:void(0);" || !$li.hasClass("is-open")) {
        e.preventDefault();
        var wasOpen = $li.hasClass("is-open");
        $("ul.dt-nav > li.menu-item-has-children").not($li).removeClass("is-open");
        if (!wasOpen) {
          $li.addClass("is-open");
        } else {
          $li.removeClass("is-open");
        }
      }
    }
  });

  // Caret click handler
  $(document).on("click", "ul.dt-nav > li.menu-item-has-children .dt-sc-caret", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $li = $(this).closest("li.menu-item-has-children");
    var wasOpen = $li.hasClass("is-open");
    $("ul.dt-nav > li.menu-item-has-children").not($li).removeClass("is-open");
    if (!wasOpen) {
      $li.addClass("is-open");
    } else {
      $li.removeClass("is-open");
    }
  });

  // Close when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest("ul.dt-nav > li.menu-item-has-children").length) {
      $("ul.dt-nav > li.menu-item-has-children").removeClass("is-open");
    }
  });

  // Close on Escape key
  $(document).on("keyup", function (e) {
    if (e.key === "Escape") {
      $("ul.dt-nav > li.menu-item-has-children").removeClass("is-open");
    }
  });
});

